import { Controller } from "@hotwired/stimulus"
import { Sortable } from "sortablejs"

// The capacity-planning card-field picker: a drag-to-reorder checkbox list. Selection + order
// round-trip via the DOM order of the checked `card_fields[]` boxes on the filter form's GET
// submit, so there is no separate reorder endpoint. Enforces the max-selected cap by disabling
// the remaining unchecked boxes once the cap is reached.
export default class extends Controller {
  static targets = ["list", "item", "checkbox", "handle"]
  static values = { max: Number }

  connect() {
    this.sortable = new Sortable(this.listTarget, {
      animation: 150,
      handle: '[data-planning-card-fields-target="handle"]',
      ghostClass: "opacity-50",
      chosenClass: "bg-green-50",
    })
    this.enforceCap()
  }

  disconnect() {
    if (this.sortable) this.sortable.destroy()
  }

  // Called on every checkbox change (data-action wired below) to re-apply the cap.
  toggle() {
    this.enforceCap()
  }

  enforceCap() {
    const max = this.maxValue || this.checkboxTargets.length
    const checked = this.checkboxTargets.filter((box) => box.checked).length
    const capReached = checked >= max
    this.checkboxTargets.forEach((box) => {
      box.disabled = capReached && !box.checked
    })
  }
}
